  (function () {
    document.addEventListener('DOMContentLoaded', function () {
      var materialWrapper = document.querySelector('[data-material-tabs]');
      var categoryWrapper = document.querySelector('[data-category-tabs]');
      var cards = document.querySelectorAll('product-card[data-material]');

      var activeMaterial = 'all';
      var activeCategory = 'all';

      function applyFilters() {
        cards.forEach(function (card) {
          var cardMaterial = card.getAttribute('data-material');
          var cardCategory = card.getAttribute('data-category');

          var materialMatch = (activeMaterial === 'all' || cardMaterial === activeMaterial);
          var categoryMatch = (activeCategory === 'all' || cardCategory === activeCategory);

          if (materialMatch && categoryMatch) {
            card.classList.remove('is-material-hidden');
          } else {
            card.classList.add('is-material-hidden');
          }
        });
      }

      if (materialWrapper) {
        var materialButtons = materialWrapper.querySelectorAll('.material-tab');
        materialButtons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            materialButtons.forEach(function (b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');
            activeMaterial = btn.getAttribute('data-material');
            applyFilters();
          });
        });
      }

      if (categoryWrapper) {
        var categoryButtons = categoryWrapper.querySelectorAll('.material-tab');
        categoryButtons.forEach(function (btn) {
          btn.addEventListener('click', function () {
            categoryButtons.forEach(function (b) { b.classList.remove('is-active'); });
            btn.classList.add('is-active');
            activeCategory = btn.getAttribute('data-category');
            applyFilters();
          });
        });
      }

      var abWrapper = document.querySelector('[data-ab-tabs]');
      if (abWrapper) {
        var abTabs = abWrapper.querySelectorAll('.material-tab');
        var alleTab = abWrapper.querySelector('[data-ab-filter="all"]');

        abTabs.forEach(function (btn) {
          btn.addEventListener('click', function () {
            var materialVal = btn.getAttribute('data-material');
            var categoryVal = btn.getAttribute('data-category');

            if (btn === alleTab) {
              activeMaterial = 'all';
              activeCategory = 'all';
              abTabs.forEach(function (b) { b.classList.remove('is-active'); });
              alleTab.classList.add('is-active');
            } else if (materialVal) {
              if (btn.classList.contains('is-active')) {
                btn.classList.remove('is-active');
                activeMaterial = 'all';
              } else {
                // Clear all active states first (making it mutually exclusive across all tabs)
                abTabs.forEach(function (b) { b.classList.remove('is-active'); });
                btn.classList.add('is-active');
                activeMaterial = materialVal;
                activeCategory = 'all'; // Clear category filter
              }
            } else if (categoryVal) {
              if (btn.classList.contains('is-active')) {
                btn.classList.remove('is-active');
                activeCategory = 'all';
              } else {
                // Clear all active states first (making it mutually exclusive across all tabs)
                abTabs.forEach(function (b) { b.classList.remove('is-active'); });
                btn.classList.add('is-active');
                activeCategory = categoryVal;
                activeMaterial = 'all'; // Clear material filter
              }
            }

            // Sync the "Alle" tab state
            if (activeMaterial === 'all' && activeCategory === 'all') {
              alleTab.classList.add('is-active');
            } else {
              alleTab.classList.remove('is-active');
            }

            applyFilters();
          });
        });
      }
    });
  })();

document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll("[data-u-card-swiper]").forEach(function (card) {
    const track = card.querySelector("[data-u-card-track]");
    const slides = card.querySelectorAll("[data-u-card-slide]");
    const dots = card.querySelectorAll("[data-u-card-dot]");
    if (!track || !slides.length || !dots.length) return;

    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          const index = Array.prototype.indexOf.call(slides, entry.target);
          dots.forEach(function (dot, i) {
            dot.classList.toggle("is-active", i === index);
          });
        }
      });
    }, { root: track, threshold: 0.6 });

    slides.forEach(function (slide) {
      observer.observe(slide);
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        slides[i].scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
      });
    });
  });
});


